export default __webpack_public_path__ + "static/media/Customer_Masive.10412012.xlsx";